import { z } from 'zod';

export const insuranceSchema = z.object({
  name: z
    .string()
    .min(1, 'Nazwa ubezpieczenia jest wymagana')
    .max(255, 'Nazwa może mieć maksymalnie 255 znaków'),
  description: z
    .string()
    .max(2000, 'Opis może mieć maksymalnie 2000 znaków')
    .optional(),
});

export type InsuranceFormData = z.infer<typeof insuranceSchema>;

export const insuranceDefaultValues: InsuranceFormData = {
  name: '',
  description: '',
};
